import {
  Flex,
  IconButton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { EditIcon } from "@chakra-ui/icons";
import { FaTrash } from "react-icons/fa";
import { useConditionalBackground } from "@/contexts/useConditionalBackground";
import {
  EDGE_COLUMN_PX,
  tableCellStylesThin,
  tableHeaderStylesThin,
} from "@/components/FinancialShared/tableStyles";
import { INegociacao } from "@/models/consignado/proposal-billings.model";
import { renderCompetencia } from "@/utils/consignado/renderCompetencia.utils";
import { formatDateTimeWithAt } from "@/utils/dateFormatter";

type Props = {
  negociacoes: INegociacao[];
  onEditar: (negociacao: INegociacao) => void;
  onExcluir: (negociacao: INegociacao) => void;
  excluindoId?: string | null;
};

// Histórico de negociações da CCB, todas as competências, na ordem em que o
// backend devolve (mais recentes primeiro).
export default function NegociacoesTable({ negociacoes, onEditar, onExcluir, excluindoId }: Props) {
  const backgroundStyle = useConditionalBackground();

  return (
    <TableContainer borderRadius="lg" overflowX="auto">
      <Table variant="simple">
        <Thead {...backgroundStyle}>
          <Tr>
            <Th {...tableHeaderStylesThin} px={EDGE_COLUMN_PX}>DATA DO CONTATO</Th>
            <Th {...tableHeaderStylesThin}>STATUS</Th>
            <Th {...tableHeaderStylesThin}>COMPETÊNCIA</Th>
            <Th {...tableHeaderStylesThin}>COMO FOI A NEGOCIAÇÃO</Th>
            <Th {...tableHeaderStylesThin} px={EDGE_COLUMN_PX}>AÇÕES</Th>
          </Tr>
        </Thead>
        <Tbody>
          {negociacoes.length === 0 && (
            <Tr>
              <Td {...tableCellStylesThin} colSpan={5} color="gray.500" py={3}>
                Nenhuma negociação registrada.
              </Td>
            </Tr>
          )}
          {negociacoes.map((negociacao) => (
            <Tr key={negociacao.id} _odd={{ bg: "blackAlpha.50" }}>
              <Td {...tableCellStylesThin} px={EDGE_COLUMN_PX}>
                {negociacao.data_contato ? formatDateTimeWithAt(new Date(negociacao.data_contato)) : "—"}
              </Td>
              <Td {...tableCellStylesThin}>{negociacao.status || "—"}</Td>
              <Td {...tableCellStylesThin}>{renderCompetencia(negociacao.competencia) || "—"}</Td>
              <Td
                {...tableCellStylesThin}
                textAlign="left"
                maxW="320px"
                whiteSpace="normal"
                wordBreak="break-word"
              >
                {negociacao.descricao || "—"}
              </Td>
              <Td {...tableCellStylesThin} px={EDGE_COLUMN_PX}>
                <Flex justifyContent="center" gap={1}>
                  <IconButton
                    aria-label="Editar negociação"
                    icon={<EditIcon />}
                    size="sm"
                    variant="ghost"
                    onClick={() => onEditar(negociacao)}
                  />
                  <IconButton
                    aria-label="Excluir negociação"
                    icon={<FaTrash />}
                    size="sm"
                    variant="ghost"
                    onClick={() => onExcluir(negociacao)}
                    isLoading={!!negociacao.id && excluindoId === negociacao.id}
                  />
                </Flex>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
}
